import React from 'react'
import Header from '../inc/Header'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import ChimneyCommercialset from "../images/Commercial Chimney.jpg";
import ChimneyCommercialset2  from "../images/Chimney Commercial 2.jpg";
import CommercialChimney3 from "../images/Chimney Commercial 5.jpg";
import CommercialChimney4 from "../images/Chimney Commercial 6.jpg";


import CommercialChimney5 from "../images/Chimney Commercial 7.jpg";
import CommercialChimney6 from "../images/Chimney Commercial 8.jpg";
import CommercialChimney7 from "../images/Chimney Commercial 9.jpg";
import CommercialChimney8 from "../images/Chimney Commercial 10.jpg";


import CommercialChimney from "../images/Chimney Commercial 3.jpg";


import CommercialChimney9  from "../images/Chimney Commercial Restuarant.jpg";




function ChimneyCommercial() {
    return (
        <div>
            <Header />
            <br />
            <br />
            <br />
            <br />
            <ScrollToTop smooth top="100" color="maroon" />
            <div className='exteriordesign'>
                <div className="album py-1">
                    <div className="container mt-3">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" >Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Chimney Commercial</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>



            <div className="album py-2">

                <div className="container ">
                    <div className="row ">
                        <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={ChimneyCommercialset} className="card-img-top" alt="ChimneyCommercial" />
                                <div className="card-body">
                                    <h5 className="card-title"> Commercial Chimney </h5>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={ChimneyCommercialset2} className="card-img-top" alt="ChimneyCommercialset2" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>
                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney3} className="card-img-top" alt="CommercialChimney3" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney4} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>


                        <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney5} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney6} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney7} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>

                          <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney8} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>

                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>

                         <div className="col-md-3 mt-3">
                            <div className="card" >
                                <img src={CommercialChimney9} className="card-img-top" alt="CommercialChimney" />
                                <div className="card-body">
                                    <h5 className="card-title">Commercial Chimney</h5>
                                </div>
                            </div>
                        </div>

                        
                    </div>
                </div>

            </div>
            <br />

        </div>
    )
}

export default ChimneyCommercial